import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
const images = [{
  src: 'https://cdn.magicpatterns.com/uploads/aAYMbmhMDc3i451pMxnr4T/WhatsApp_Image_2026-08-23_at_14.25.45_(5).webp',
  alt: 'Página del manual: el corte transversal, ingeniería de la fibra final',
  caption: 'Ingeniería de élite: planos detallados para transformar bloques secos en piezas de diseño.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/h5FrgBssWnhEA8QTGTpHzu/WhatsApp_Image_2026-08-23_at_14.25.45_(4).webp',
  alt: 'Página del manual: ciclo de lijado maestro, de rugoso a seda',
  caption: 'El paso a paso del acabado: domina la técnica para conseguir texturas de seda.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vwfajM2LHt5H2gQt1LQL5G/WhatsApp_Image_2026-08-23_at_14.25.45.webp',
  alt: 'Página del manual: torre plegable con seguridad y diseño plegable',
  caption: 'Diseño inteligente: planos optimizados para espacios pequeños y máxima seguridad.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2T2JDNY3VJv7hKpxJf1Bk9/WhatsApp_Image_2026-08-23_at_14.25.45_(3).webp',
  alt: 'Página del manual: cómo fabricar 5 piezas a la vez en producción por lotes',
  caption: 'Multiplica tu tiempo: hoja de ruta para fabricar 5 piezas a la vez sin errores.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/f1BpAgcDDohmQxJKRKknGL/WhatsApp_Image_2026-08-23_at_14.25.45_(2).webp',
  alt: 'Página del manual: las 3 fotos que generan compras',
  caption: 'Marketing visual: aprende a tomar las fotos que hacen que el cliente compre al instante.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/npuDe6QRsQo4Bx2246udj1/WhatsApp_Image_2026-08-23_at_14.25.45_(1).webp',
  alt: 'Página del manual: cómo convertir el taller en contenido que vende',
  caption: 'Estrategia de visibilidad: cómo convertir tu trabajo diario en ventas reales en redes sociales.'
}];
export function InsideKit() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-116" data-mp="2wpk7u8chmye1">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-117" data-mp="2wp23spjl3fvk">
        <SectionTag icon="📸" data-id="element-118" data-mp="31nde11dsjseb">Vistazo al interior</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl" data-id="element-119" data-mp="36f3snjjrh2bj">
          Vistazo al Interior del Kit
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-120" data-mp="3ag79a89mv2dt">
          Planos técnicos, despieces en milímetros y guías de acabado con la misma calidad visual que ves
          aquí, en cada una de las páginas.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-4xl px-4 sm:px-6" data-id="element-121" data-mp="2mre73u2f3yar">
        <p className="text-center text-base leading-relaxed text-muted sm:text-lg" data-id="element-122" data-mp="2mptei9znypfj">
          Nuestros alumnos no solo leen, fabrican. Así se ven los planos del Kit en un taller real,
          guiándote paso a paso en tu tablet o móvil mientras trabajas.
        </p>

        <div className="mt-6 grid gap-5 sm:grid-cols-2" data-id="element-123" data-mp="6yyvbzi10mod">
          <m.figure initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4
        }} data-id="element-124" data-mp="h3xaxzhdn04u">
            <div className="group overflow-hidden rounded-2xl border border-brown/20 bg-white shadow-card" data-id="element-125" data-mp="7dvofc4o9ps1">
              <img src="https://cdn.magicpatterns.com/uploads/gud4tey4B9FrKZXoEuR45T/ChatGPT_Image_27_ago_2026,_16_53_13_(1).webp" alt="Fabricando la Torre Montessori plegable en el taller, siguiendo el plano en la tablet" loading="lazy" decoding="async" className="aspect-[4/5] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-105" data-id="element-126" data-mp="3d20iir8caz5" />
            </div>
            <figcaption className="mt-3 text-center font-heading text-sm font-semibold leading-snug text-ink" data-id="element-127" data-mp="1itajubh8g9l1">
              Fabricando la Torre Montessori plegable usando el Tomo 1.
            </figcaption>
          </m.figure>

          <m.figure initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.08
        }} data-id="element-128" data-mp="1lum2w1a0umi9">
            <div className="group overflow-hidden rounded-2xl border border-brown/20 bg-white shadow-card" data-id="element-129" data-mp="1ct5uu06oiwh7">
              <img src="https://cdn.magicpatterns.com/uploads/egbPTZqMR4x6ifMaJCVjfA/ChatGPT_Image_27_ago_2026,_16_55_17_(1).webp" alt="Acabando el soporte de laptop en nogal, siguiendo el plano en la tablet" loading="lazy" decoding="async" className="aspect-[4/5] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-105" data-id="element-130" data-mp="1guhnyforhzu5" />
            </div>
            <figcaption className="mt-3 text-center font-heading text-sm font-semibold leading-snug text-ink" data-id="element-131" data-mp="k507d5o8qtdo">
              Resultado profesional en el soporte de laptop con acabado en nogal.
            </figcaption>
          </m.figure>
        </div>
      </div>

      <div className="mx-auto mt-8 max-w-6xl px-4 sm:px-6" data-id="element-132" data-mp="5kxi5b89l9t7">
        <div className="scrollbar-hide flex snap-x snap-mandatory gap-5 overflow-x-auto pb-2 sm:grid sm:grid-cols-2 sm:overflow-visible lg:grid-cols-3" data-id="element-133" data-mp="l1mq0dmuqp9">
          {images.map((image, i) => <m.figure key={image.src} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.05
        }} className="w-[240px] flex-shrink-0 snap-center sm:w-auto" data-id="element-134" data-mp="aguul6gepw0p" data-mpi={i}>
              <div className="group overflow-hidden rounded-2xl border border-brown/20 bg-white shadow-card" data-id="element-135" data-mp="y9l8vmbs8re5">
                <img src={image.src} alt={image.alt} loading="lazy" decoding="async" className="aspect-[4/5] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-105" data-id="element-136" data-mp="1786kexiu765f" />
              </div>
              <figcaption className="mt-3 text-center font-heading text-sm font-semibold leading-snug text-ink" data-id="element-137" data-mp="4u8zzmey9rso">
                {image.caption}
              </figcaption>
            </m.figure>)}
        </div>
        <p className="mt-3 text-center text-xs text-muted sm:hidden" data-id="element-138" data-mp="do46axrt5o9w">← Desliza para ver más ejemplos →</p>
      </div>
    </section>;
}